module.exports = __webpack_public_path__ + "static/media/BAT.304aa2ea.svg";